import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { EmailTemplateSelectProps } from "./EmailTemplateSelect.type";

export function EmailTemplateSelect({
  templates,
  value,
  disabled,
  onChange,
}: EmailTemplateSelectProps) {
  const handleVisitorEmailPolicyChange = (
    event: SelectChangeEvent<unknown>,
  ) => {
    onChange(event.target.value as number);
  };

  return (
    <Select
      value={value ?? ""}
      onChange={handleVisitorEmailPolicyChange}
      disabled={disabled}
      fullWidth
    >
      {templates.map((template) => (
        <MenuItem key={template.id} value={template.id}>
          {template.name}
        </MenuItem>
      ))}
    </Select>
  );
}
